// extracted by mini-css-extract-plugin
export var fadeInAnimation = "steps-module--fadeInAnimation--eb183";
export var item = "steps-module--item--f5759";
export var itemDescription = "steps-module--itemDescription--36d9c";
export var itemName = "steps-module--itemName--2f4d7";
export var section = "steps-module--section--14be0";